import LocalDatabaseService from "../../services/localDatabaseService.js";
import apiSoapDB from "../../api/soapdb";

export default {
  namespaced: true,

  state: {
    dbService: null,
    accountGroups: null, //WAS ENTITIES BUT TECHNICALLY GROUPS . . . . . EVENTUALLY entities (tagged GCS/DCP) -> accounts (tagged GCS/DCP)
  },

  getters: {
    dbService(state) {
      return state.dbService;
    },
    accountGroups(state) {
      return state.accounts ?? {};
    },
  },

  mutations: {
    setDbService(state, newDbService) {
      state.dbService = newDbService;
    },
    setAccountGroups(state, acctGrps) {
      state.accountGroups = acctGrps ?? {};
    },
  },

  actions: {
    async setup({ commit, dispatch, state }) {
      commit("setDbService", new LocalDatabaseService());
      // return Promise.all([dispatch("initDb"), dispatch("refreshAllTables")]);
      return Promise.all([dispatch("initDb")]);
    },
    async initDb(context) {
      return new Promise((resolve, reject) => {
        context.state.dbService
          .setup()
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async collectAccountSummaries() {
      return new Promise((resolve, reject) => {
        //TODO: SOON
      });
    },
    async refreshAllTables(context) {
      //ACQUIRE USER INFORMATION
      const curUserFromAuthModule = context.rootGetters["auth/currentUser"];

      return new Promise((resolve, reject) => {
        apiSoapDB
          .doRefreshTables(curUserFromAuthModule.clientId, curUserFromAuthModule.accountId)
          .then((resp) => {
            if (
              resp.soapResultSection &&
              resp.soapResultSection.item &&
              Array.isArray(resp.soapResultSection.item)
            ) {
              // const multiQuery = resp.soapResultSection.item.join(";") + ";";
              // console.log("MULTIQUERY:", multiQuery); //MULTIQUERY TOO LONG TO EXECUTE
              // context.state.dbService.runQuery(multiQuery);

              let i = 0;
              let len = resp.soapResultSection.item.length;
              while (i < len) {
                context.state.dbService.runQuery(resp.soapResultSection.item[i] + ";");
                // console.log("REMAINING: " + (len - i));
                i++;
              }
            }
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
